<template>
  <div class="Personal wide-container">
    <ul class="titleList">
      <li class="title">我的管理</li>
      <!-- <li
        :class="{ selected: curPath === '/mall/personal/cart' }"
        @click="navTo('/mall/personal/cart')"
      >
        购物车
      </li> -->

      <li
        :class="{ selected: curPath === '/mall/personal/myAddress' }"
        @click="navTo('/mall/personal/myAddress')"
      >
        收货地址
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/changePwd' }"
        @click="navTo('/mall/personal/changePwd')"
      >
        修改密码
      </li>
      <li class="title">订单中心</li>
      <li
        :class="{ selected: curPath === '/mall/personal/myOrder' }"
        @click="navTo('/mall/personal/myOrder')"
      >
        我的订单
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/Shelves' }"
        @click="navTo('/mall/personal/Shelves')"
      >
        上架审核
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/Purchase' }"
        @click="navTo('/mall/personal/Purchase')"
      >
        采购审核
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/returnGoods' }"
        @click="navTo('/mall/personal/returnGoods')"
      >
        退货申请
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/barter' }"
        @click="navTo('/mall/personal/barter')"
      >
        换货申请
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/repair' }"
        @click="navTo('/mall/personal/repair')"
      >
        维修申请
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/extraStandard' }"
        @click="navTo('/mall/personal/extraStandard')"
      >
        标外维修
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/commodityApplication' }"
        @click="navTo('/mall/personal/commodityApplication')"
      >
        标外商品申请
      </li>

      <!-- <li
        :class="{ selected: curPath === '/mall/personal/myData' }"
        @click="navTo('/mall/personal/myData')"
      >
        修改资料
      </li> -->
      <li class="title">更多</li>
      <li
        :class="{ selected: curPath === '/mall/personal/satisfaction' }"
        @click="navTo('/mall/personal/satisfaction')"
      >
        满意度评测
      </li>
      <li
        :class="{ selected: curPath === '/mall/personal/wechat' }"
        @click="navTo('/mall/personal/wechat')"
      >
        微信客服
      </li>
    </ul>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Personal",
  computed: {
    ...mapState(["clientToken", "clientName"]),
    form_head_uuid () {
      return this.$store.state.form_head_uuid
    }
  },
  data () {
    return {
      curPath: this.$route.path,
    };
  },

  methods: {
    navTo (route) {
      this.$router.push(route);
    },
  },

  mounted () { },

  watch: {
    $route (to, from) {
      this.curPath = to.path;
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.Personal {
  padding: 16px 0 60px;
  display: flex;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;

  .titleList {
    width: 200px;
    background: #ffffff;
    border: 1px solid @brandBorder;
    border-radius: 10px;
    padding: 16px 12px;
    box-shadow: 0 2px 8px rgba(0, 40, 100, 0.03);
    box-sizing: border-box;
    list-style: none;
    margin: 0;
    flex-shrink: 0;

    li {
      width: 100%;
      padding: 10px 14px;
      font-size: 13px;
      color: @brandTextLight;
      cursor: pointer;
      border-radius: 6px;
      transition: all 0.15s ease;
      box-sizing: border-box;
      margin-bottom: 2px;

      &:hover {
        color: @brandPrimary;
        background-color: #f8fafc;
      }

      &.selected {
        background-color: #f0f5ff;
        color: @brandPrimary;
        font-weight: 600;
      }

      &.title {
        font-size: 14px;
        font-weight: 700;
        color: @brandTextDark;
        padding: 14px 14px 6px;
        cursor: default;
        background: transparent !important;
        margin-top: 6px;

        &:first-child {
          margin-top: 0;
        }
      }
    }
  }

  .content {
    flex: 1;
    min-width: 0;
    background: transparent;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/Personal.vue